<template>
  <div>
    <d-header fluid>
      <h1 class="title is-spaced has-text-centered">
        {{ $t("application_files") }}
      </h1>
      <h3
        v-if="model"
        class="subtitle is-6 has-text-centered"
      >
        {{ model.application_file.property.full_address_with_unity }}
      </h3>
    </d-header>
    <d-container
      v-if="model && model.applicant.is_completed"
      paddingless-mobile
      fluid
      class="mt-10"
    >
      <d-card>
        <d-card-row>
          <div class="is-flex is-align-items-center is-justify-content-center">
            <i class="mdi mdi-check-circle mdi-48px is-color-success" />
            <h2 class="title mt-1">
              {{ $t('application_file_is_completed_msg') }}
              </p>
            </h2>
          </div>
        </d-card-row>
      </d-card>
    </d-container>


    <d-container
      v-if="model && ! model.applicant.is_completed"
      paddingless-mobile
      fluid
    >
      <div v-if="!model.applicant.has_accepted_terms_at">
        <h2 class="title is-5 mr-5">
          {{ $t('acceptance_of_terms_and_general_conditions') }}
        </h2>
        <ApplicantAcceptation
          :data="model"
          @success="query"
        />
      </div>
      <div v-if="model.applicant.has_accepted_terms_at">
        <VApplicantSteps
          :loading="loading"
          :applicant="model.applicant"
          :application-file="model.application_file"
          @success="query"
        />
      </div>
    </d-container>
  </div>
</template>

<script>

import { i18n } from "@/services/i18n";
import ApplicantAcceptation from "@/shared/applicant/ApplicantAcceptation";
import ApplicantSteps from "@/shared/applicant/ApplicantSteps";

export default {
  components: {
    "ApplicantAcceptation": ApplicantAcceptation,
    "VApplicantSteps": ApplicantSteps,
  },
  metaInfo() {
    return {
      title: i18n.t("application_files"),
    };
  },
  data() {
    return {
      model: null,
      loading: false,
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      this.loading = true;
      this.$http
        .get(
          this.$laravel.route("public.application_files.applicant", {
            application_file: this.$route.params.application_file,
            email: this.$route.params.email
          })
        )
        .then(response => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch(error => {
          this.loading = false;
        });
    }
  }
};

</script>

<style scoped>
  .is-color-success {
    color: #4CAF50;
    margin-right: 10px;
  }

</style>
